// export default IncidentRequest;
import DeleteModal from "components/DeleteModal";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deletePoliceStation } from "services/externalUserService";
import { PoliceStation, InvestigationFile } from "types";
import { deleteIcon, editIcon } from "utils/constant";
import { errorHandler } from "utils/helper";
import PoliceStationForm from "./modal/PoliceStaionForm";

type Props = {
  policeSations: PoliceStation[];
  fetchData: () => void;
};

const PoliceStations: React.FC<Props> = ({ policeSations, fetchData }) => {
  const { showTooltip } = useTooltip();
  const menuRef = useRef<HTMLDivElement | null>(null);

  const [action, setAction] = useState<"Add" | "Edit">("Add");
  const [fileTooltip, setFileTooltip] = React.useState<InvestigationFile>();
  const [isOpenForm, setIsOpenForm] = React.useState(false);
  const [selectedPolice, setSelectedPolice] = React.useState<PoliceStation>();

  const [search, setSearch] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const navigate = useNavigate();

  const searchTerm = search.trim().toLowerCase();
  const filteredInvestigations = policeSations.filter((investigation) => {
    // 1️⃣ — existing text‑search fields
    const name = investigation?.name?.toLowerCase() || "";
    const address = investigation?.address?.toString()?.toLowerCase() || "";
    const city = investigation?.city?.toLowerCase() || "";
    const house_number = investigation?.house_number?.toLowerCase() || "";
    const kebele = investigation?.kebele?.toLowerCase() || "";
    const region = investigation?.region?.toLowerCase() || "";
    const zone = investigation?.region?.toLowerCase() || "";

    const matchesText =
      city.includes(searchTerm) ||
      name.includes(searchTerm) ||
      address.includes(searchTerm) ||
      address.includes(searchTerm) ||
      house_number.includes(searchTerm) ||
      region.includes(searchTerm) ||
      zone.includes(searchTerm) ||
      kebele.includes(searchTerm);

    // 3️⃣ — only keep items that match BOTH
    return matchesText;
  });

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setFileTooltip(undefined);
      }
    }
    if (fileTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [fileTooltip]);

  const handleOpenForm = () => {
    setIsOpenForm(true);
  };
  const handleCloseForm = (refetch = false) => {
    setIsOpenForm(false);
    // if (refetch) fetchData();
  };

  return (
    <div>
      <div className="flex justify-end">
        <button
          onClick={() => {
            setAction("Add");
            handleOpenForm();
          }}
          className="mb-3  px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
        >
          Add Police Station
        </button>
      </div>

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
          <div className="overflow-hidden bg-white shadow rounded-xl">
            <table className="w-full text-sm border-collapse">
              <thead className="text-white bg-black">
                <tr>
                  <th colSpan={10} className="p-4" rounded-t-lg>
                    <div className="flex items-center justify-between">
                      {/* Left: Back + Title */}
                      <div className="flex items-center gap-2 text-lg font-semibold">
                        <button
                          onClick={() => navigate(-1)}
                          className="text-white hover:text-gray-300"
                          title="Go Back"
                        >
                          ◀️
                        </button>
                        <span>External Police</span>
                      </div>

                      {/* Right: Search Box */}
                      <div className="relative w-80">
                        <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                          🔍
                        </span>
                        <input
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search"
                          className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                        />
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  {/* <th className="p-3 text-left">Reporter</th> */}
                  <th className="p-3 text-left">Name</th>
                  <th className="p-3 text-left">Zone</th>
                  <th className="p-3 text-left">Woreda</th>
                  <th className="p-3 text-left">City</th>
                  <th className="p-3 text-left" rounded-tr-lg>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredInvestigations.map((file, idx) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                  >
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file?.name}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file?.zone}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {file?.woreda}
                    </td>
                    <td className="p-3 capitalize font-[500] font-[Poppins]">
                      {file?.city}
                    </td>
                    <td className="p-3 flex flex-row gap-2 font-[500] font-[Poppins]">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setAction("Edit");
                          setSelectedPolice(file);
                          setIsOpenForm(true);
                        }}
                      >
                        {editIcon}
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedPolice(file);
                          setIsOpenDelete(true);
                        }}
                      >
                        {deleteIcon}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {isOpenForm && (
        <PoliceStationForm
          action={action}
          externalPolice={selectedPolice}
          onClose={(refetch) => {
            handleCloseForm(refetch);
            if (refetch) {
              fetchData();
            }
          }}
        />
      )}

      {selectedPolice && (
        <DeleteModal
          isOpen={isOpenDelete}
          onConfirm={() => {
            deletePoliceStation(selectedPolice)
              .then(() => {
                showTooltip("Successfully Deleted!", "success");
                // fetchData();
              })
              .catch((error) => {
                showTooltip(
                  error?.response?.data?.detail || errorHandler(error)
                );
              });
          }}
          onCancel={() => {
            setIsOpenDelete(false);
          }}
          title="Delete External Police"
          message={`Are you sure you want to delete this police station called 
            ${selectedPolice?.name}`}
        />
      )}
    </div>
  );
};

export default PoliceStations;
